import React from 'react';
import Button from '@mui/material/Button'

function CreateProject() {
  return <div>
      <Button>Delete projct</Button>
  </div>;
}

export default CreateProject;
